import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CalculationStateService } from '../../../optimistic-planning/calculation-state.service';
import { FrontendUpdateService } from '../../services/frontend-update.service';
import { PendingWriteService } from '../../services/pending-write.service';

@Component({
  selector: 'frontend-update',
  templateUrl: './frontend-update.component.html',
  styleUrls: ['./frontend-update.component.scss']
})
export class FrontendUpdateComponent implements AfterViewInit, OnDestroy {
  @ViewChild('dialog', { static: true }) dialog: ElementRef;
  private subscription: Subscription;
  private blocked = false;

  constructor(private readonly updates: FrontendUpdateService,
              private readonly writes: PendingWriteService,
              private readonly calculations: CalculationStateService) {}

  get busy(): boolean {
    return this.writes.count > 0 || this.calculations.operations.some(operation =>
      operation.status === 'Calculating' || operation.queuedActionStatus === 'pending' ||
      operation.queuedActionStatus === 'executing');
  }

  private readonly guardKeyboard = (event: KeyboardEvent) => {
    if (!this.blocked) { return; }
    // Window capture precedes existing document/application shortcuts. Native dialog
    // focus trapping and button activation still use the key's default action.
    event.stopImmediatePropagation();
    if (event.key === 'Escape') { event.preventDefault(); }
  };

  ngAfterViewInit(): void {
    window.addEventListener('keydown', this.guardKeyboard, true);
    window.addEventListener('keypress', this.guardKeyboard, true);
    window.addEventListener('keyup', this.guardKeyboard, true);
    this.subscription = this.updates.updateRequired$.subscribe(required => {
      if (required && !this.blocked) {
        this.blocked = true;
        // Native modal dialogs put the rest of the document in the inert state,
        // including previously opened Bootstrap/Kendo modals and other app roots.
        this.dialog.nativeElement.showModal();
      }
    });
    this.updates.start();
  }

  reload(): void {
    if (this.busy) { return; }
    window.location.reload();
  }

  preventDismiss(event: Event): void { event.preventDefault(); }

  ngOnDestroy(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
    window.removeEventListener('keydown', this.guardKeyboard, true);
    window.removeEventListener('keypress', this.guardKeyboard, true);
    window.removeEventListener('keyup', this.guardKeyboard, true);
  }
}
